import React from 'react';
import { FaCrosshairs } from 'react-icons/fa';
import { YDialog } from '../../../ui/dialog/YDialog';
import { YButton } from '../../../ui/YButton';
import { formatMajorWindow, getForecastScoreLabel } from '../huntForecastUtils';

export default function ForecastTagOutDialog({ show, onHide, pick, onConfirm }) {
  const score = pick?.day?.score;
  const { label } = getForecastScoreLabel(score);

  const footer = (
    <>
      <YButton variant="secondary" onClick={onHide}>
        Cancel
      </YButton>
      <YButton variant="primary" onClick={() => onConfirm?.(pick)}>
        Confirm
      </YButton>
    </>
  );

  return (
    <YDialog
      show={show}
      onHide={onHide}
      title="Tag Out to Hunt?"
      size="sm"
      testId="hf-tag-out-dialog"
      bodyClassName="hf-tag-dialog"
      footer={footer}
    >
      {pick ? (
        <>
          <div className="hf-tag-dialog__icon" aria-hidden="true">
            <FaCrosshairs />
          </div>
          <p className="hf-tag-dialog__copy">
            You&apos;ll sign out at
            {' '}
            <strong>{pick.name}</strong>
            . Other club members will see this stand as occupied.
          </p>
          <div className="hf-tag-dialog__summary">
            <div className="hf-tag-dialog__row">
              <span>Forecast</span>
              <span className={`hf-score-tone--${getForecastScoreLabel(score).tone}`}>
                {score != null ? `${score}/100 · ${label}` : '—'}
              </span>
            </div>
            <div className="hf-tag-dialog__row">
              <span>Next window</span>
              <span>{formatMajorWindow(pick)}</span>
            </div>
          </div>
        </>
      ) : null}
    </YDialog>
  );
}
